import React from 'react';

const findColor = (color, colorList) =>
	colorList.find(x => color && color.toLowerCase().includes(x));

const getColorForSwatch = (normalColor, fullColor) => {
	const colorList = [
		'beige',
		'black',
		'blue',
		'brown',
		'gold',
		'gray',
		'grey',
		'green',
		'orange',
		'purple',
		'red',
		'silver',
		'white',
		'yellow'
	];

	return findColor(normalColor, colorList) || findColor(fullColor, colorList);
};

const ColorSwatch = props => {
	const { normalizedColor, fullColor, swatchDeviceClass } = props;
	const colorForSwatch = getColorForSwatch(normalizedColor, fullColor);
	// Return null if we can't reliably match a color
	return (
		(colorForSwatch && (
			<span
				className={`normalized-swatch normalized-swatch-${colorForSwatch} ${swatchDeviceClass}`}
			/>
		)) ||
		null
	);
};

export default ColorSwatch;



// WEBPACK FOOTER //
// ./src/components/ColorSwatch.jsx